import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const HERO_BG =
  'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20dark%20background%20collage%20of%20city%20office%20silhouettes%2C%20rising%20newspaper%20pages%20and%20a%20megaphone%20in%20warm%20vermilion%20red%20and%20amber%20ink%20on%20deep%20charcoal%2C%20dramatic%20spotlight%2C%20film%20grain%20texture%2C%20abstract%20reportage%20concept%2C%20high%20contrast%2C%20moody%2C%20no%20text&width=1600&height=900&seq=hero-editorial-1&orientation=landscape';

function scrollToId(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function Hero() {
  const lead = articles[0];
  const top3 = [articles[5], articles[7], articles[1]];

  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <img src={HERO_BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-foreground-950"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16 lg:py-20">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-8">
          {/* 左侧主文案 */}
          <div className="flex flex-col justify-center lg:col-span-7">
            <p className="inline-flex w-fit items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-3 py-1 text-xs font-medium text-accent-300">
              <i className="ri-radio-2-line" aria-hidden="true"></i>
              51爆料 · 今日一线 · 每日更新
            </p>
            <h1 className="mt-5 font-display text-3xl font-black leading-tight text-background-50 md:text-5xl">
              看清公司真实情况
              <br />
              <span className="text-accent-400">掌握别人不知道的内部动态</span>
            </h1>
            <p className="mt-5 max-w-xl text-base leading-8 text-background-300 md:text-lg">
              51爆料汇集前员工、知情人士提供的高管动态、组织变动与职场内幕。匿名投稿、人工分级核实，帮你在跳槽与选择前，看清一家公司最真实的一面。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <button
                type="button"
                onClick={() => scrollToId('feed')}
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-500"
              >
                <i className="ri-flashlight-fill" aria-hidden="true"></i>
                浏览实时爆料
              </button>
              <Link
                to="/about#contact"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300/50 bg-background-50/5 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-100 backdrop-blur transition-colors hover:border-accent-400/60 hover:text-accent-300"
              >
                <i className="ri-megaphone-fill" aria-hidden="true"></i>
                我也要爆料
              </Link>
            </div>

            {/* 快捷入口 */}
            <div className="mt-8 flex flex-wrap gap-2">
              <span className="mr-1 flex items-center gap-1 text-xs text-background-400">
                <i className="ri-fire-line text-accent-400" aria-hidden="true"></i>
                正在热议
              </span>
              {top3.map((a) => (
                <Link
                  key={a.id}
                  to={`/article/${a.id}`}
                  className="rounded-full border border-background-300/40 px-3 py-1 text-xs text-background-200 transition-colors hover:border-accent-400/70 hover:text-accent-300"
                >
                  {a.title.slice(0, 14)}…
                </Link>
              ))}
            </div>
          </div>

          {/* 右侧头条推荐卡 */}
          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-200/20 bg-foreground-900/60 p-5 backdrop-blur md:p-6">
              <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-400">
                <span className="inline-block h-3 w-1.5 rounded-sm bg-accent-500" aria-hidden="true"></span>
                今日焦点
              </p>
              <h2 className="mt-3 font-display text-lg font-bold leading-relaxed text-background-50">
                {lead.title}
              </h2>
              <p className="mt-2 line-clamp-3 text-sm leading-7 text-background-300">{lead.excerpt}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/20 pt-4">
                <span className="flex items-center gap-1 text-xs text-background-400">
                  <i className="ri-quill-pen-line text-accent-400" aria-hidden="true"></i>
                  {lead.author} · {lead.role}
                </span>
                <Link
                  to={`/article/${lead.id}`}
                  className="inline-flex items-center gap-1 rounded-md bg-background-50 px-3 py-1.5 text-xs font-semibold text-foreground-950 transition-colors hover:bg-accent-500"
                >
                  阅读全文
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}